import * as Scrivito from "scrivito";
import moment from "moment";
import I18n from "^/config/i18n";
import formatDate from "../../utils/formatDate";

function EventDateHeader({ date, endDate }) {
  if (date === null || endDate === null) {
    return null;
  }
  if (endDate.getTime() < date.getTime()) {
    return (
      <div>
        <h3 className="mb-0">{I18n.t("Event warning date")}</h3>
      </div>
    );
  }
  if (endDate.getTime() === date.getTime()) {
    return <SameTimeBlock date={date} />;
  }
  if (moment(date).isSame(moment(endDate), "day")) {
    return <SameDateBlock startDate={date} endDate={endDate} />;
  }
  return (
    <div>
      <meta itemProp="startDate" content={formatDate(date)} />
      <DateBlock date={date} />
      <DateBlock date={endDate} />
    </div>
  );
}

function SameTimeBlock({ date }) {
  return (
    <div>
      <meta itemProp="startDate" content={formatDate(date)} />
      <h3 className="mb-0">{formatDate(date, "DD. MMM")}</h3>
    </div>
  );
}

function SameDateBlock({ startDate, endDate }) {
  return (
    <div>
      <meta itemProp="startDate" content={formatDate(startDate)} />
      <h3 className="mb-0">
        {formatDate(startDate, "DD. MMM YYYY")}
        <span className="d-block text-uppercase font-weight-light mb-0">
          {formatDate(startDate, "HH:mm")} - {formatDate(endDate, "HH:mm")}
        </span>
      </h3>
    </div>
  );
}

function DateBlock({ date }) {
  return (
    <h3 className="mb-0">
      {formatDate(date, "DD. ")}{" "}
      <span className="text-uppercase font-weight-light mb-0">
        {formatDate(date, "MMM YYYY")}
      </span>
    </h3>
  );
}

export default Scrivito.connect(EventDateHeader);
